import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';
import RouteDataBasicInformationPropTypes from '../proptypes/RouteDataBasicInformationPropTypes';

const RouteDataBasicInformationResource = ({
  id,
  serviceStartDate,
  serviceEndDate,
  createDate,
}) => (
  <>
    <ResourceProperty label="Fecha de Inicio de Servicio:">
      {tzNormalizeDate({
        date: serviceStartDate,
        format: DATE_TIME_FORMAT,
      }) || '-'}
    </ResourceProperty>
    <ResourceProperty label="Fecha de Fin de Servicio:">
      {tzNormalizeDate({
        date: serviceEndDate,
        format: DATE_TIME_FORMAT,
      }) || '-'}
    </ResourceProperty>
    <h3 className="mt-3">Información interna</h3>
    <ResourceProperty label="ID: ">{id || '-'}</ResourceProperty>
    <ResourceProperty label="Fecha de creación: ">
      {tzNormalizeDate({
        date: createDate,
        format: DATE_TIME_FORMAT,
      }) || '-'}
    </ResourceProperty>
  </>
);

RouteDataBasicInformationResource.propTypes =
  RouteDataBasicInformationPropTypes;

export default RouteDataBasicInformationResource;
